export default $axios => {   
    return {
        async get() {
            return await $axios.get(`/simulator/comparing`);  
        },
    
        async add(id) {
            return await $axios.post(`/simulator/comparing/${id}`);  
        },
    
        async remove(id) {
            return await $axios.delete(`/simulator/comparing/${id}`);  
        },
    
        async clear() {
            return await $axios.post(`/simulator/comparing/clear`);  
        }
    } 
}; 